import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div>Caricamento…</div>;
  const cards = [
    { label: "Immobili totali", v: s.total_properties, to: "/admin/immobili" },
    { label: "In Galleria", v: s.published, to: "/admin/immobili?published=true" },
    { label: "Venduti", v: s.venduti || 0, to: "/admin/immobili?stato=venduto" },
    { label: "Richieste nuove", v: s.new_leads, to: "/admin/leads?status=nuovo" },
    { label: "Agenzie partner", v: s.agencies, to: "/admin/agenzie" },
    { label: "Pronto alla Vendita", v: s.pronto, to: "/admin/immobili?esito=pronto" },
    { label: "Con Criticità", v: s.criticita, to: "/admin/immobili?esito=criticita" },
    { label: "PTI e Aziende", v: s.technicians, to: "/admin/tecnici" },
  ];
  const gdprMissing = s.sellers_no_gdpr || 0;
  return (
    <div data-testid="admin-dashboard">
      <div className="label-uppercase">Overview</div>
      <h1 className="font-serif text-4xl mt-2 mb-8">Buongiorno.</h1>
      {gdprMissing > 0 && (
        <Link
          to="/admin/venditori"
          data-testid="alert-gdpr-missing"
          className="mb-6 flex items-center justify-between border border-[#91590F] bg-[#FDF6EA] px-4 py-3 hover:bg-[#F8EDD1] transition-colors"
        >
          <div className="text-sm text-[#7A4A0C]">
            <strong>Consenso GDPR mancante</strong> — {gdprMissing} venditor{gdprMissing === 1 ? "e" : "i"} da ricontattare per completare il consenso al trattamento dati.
          </div>
          <span className="label-uppercase text-xs text-[#7D2E3F]">Apri anagrafica →</span>
        </Link>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={`stat-${c.label.toLowerCase().replace(/ /g,"-")}`} className="admin-card p-6 hover:border-[#7D2E3F] transition-colors">
            <div className="label-uppercase">{c.label}</div>
            <div className="font-serif text-4xl text-[#7D2E3F] mt-3">{c.v}</div>
          </Link>
        ))}
      </div>
      <div className="mt-10 grid md:grid-cols-2 gap-6">
        <Link to="/admin/immobili" className="admin-card p-8 hover:border-[#7D2E3F]">
          <div className="label-uppercase mb-3">Azione rapida</div>
          <div className="font-serif text-2xl">Gestisci immobili e fascicoli</div>
        </Link>
        <Link to="/admin/leads" className="admin-card p-8 hover:border-[#7D2E3F]">
          <div className="label-uppercase mb-3">Azione rapida</div>
          <div className="font-serif text-2xl">Inbox richieste dal sito ({s.new_leads})</div>
        </Link>
      </div>
    </div>
  );
}
